module.exports = __webpack_public_path__ + "static/media/4pic.18a375b5.png";